import React, { Component } from 'react';
import { Grid } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { PlaceActiveIcon, LocationOnIcon, PlaceActiveIcon2x } from './icons';
import CustomTypo from './CustomTypo';
import { LinkCTA } from './Link'
const styles = theme => ({
    container: {
        position: "absolute",
        // top:'50%',
        userSelect: "none",
        transform: "translate(-50%, -50%)",
        cursor: 'pointer'
    },
    underline:{
        textDecoration:'underline',
        cursor:'pointer'
    },
    markerInfo: {
        position: "absolute",
        top: -60,
        left: -60,
        width: 220,
        padding: theme.spacing(2),
        backgroundColor: theme.palette.background.secondary
    },
    place:{
        marginTop: -50
    }
})
class Marker extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showInfo: null,
            info: null
        }
        this.onClick = this.onClick.bind(this);
    }
    onClick(info) {
        this.setState({ showInfo: info.id, info: info });
        // if(this.props.onClick)
        //     this.props.onClick();
    }
    render() {
        const { info, classes, onSelect,markerSelected,onClick, myPlace } = this.props;
        const contact_info = info&&info.contact_info?info.contact_info:null
        var description = info&&info.description?info.description:''
        var phone = null
        var email = null
        if (contact_info&&contact_info.length>0){
            for(var i=0;i<contact_info.length;i++){
                if(contact_info[i].type==='EMAIL'){
                    email = contact_info[i].value
                }
                else if(contact_info[i].type==='PHONE') {
                    phone = contact_info[i].value
                }
            }
        }
        // description = phone?description+' • '+phone:description;
        // description = email?description+' • '+email:description;
        return (
            <div className={classes.container}>
                {myPlace&&<PlaceActiveIcon2x className={classes.place}/>}
                {!myPlace&&onClick&&<LocationOnIcon onClick={() => onClick(info.id)} data-map-location-id={info.id}/>}
                {!myPlace&&!onClick&&<LocationOnIcon />}
                {markerSelected && markerSelected===info.id && <div className={classes.markerInfo}>
                    <Grid xs={12} item container direction='row'>
                        <Grid xs={9} item>
                            <CustomTypo variant='body2'>{info.title}</CustomTypo>
                        </Grid>
                        <Grid xs={3} item container justify='flex-end'>
                            <CustomTypo data-marker-select-id={info.id} onClick={onSelect}variant='body2' color="secondary" className={classes.underline}>Select</CustomTypo>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <CustomTypo variant='description'>{' • '}{description}</CustomTypo>
                        {phone && <Grid item >
                            <CustomTypo variant='description'>{' • '}{phone}</CustomTypo>
                        </Grid>}
                        {email && <Grid item >
                            <CustomTypo variant='description'>{' • '}{email}</CustomTypo>
                        </Grid>}
                    </Grid>
                </div>}
            </div>
        )
    }
}
export default withStyles(styles)(Marker)